import Client from './Clients/AxiosClient'
const resource = 'api'

export default {
  createPixamiUser (userId, affiliateName) {
    return Client.post(`${resource}/pixami/add_user`, { user_id: userId, affiliate_name: affiliateName })
      .then(response => response.data)
  }
}
